import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
const IKeyboardLayoutService = ( createDecorator('keyboardLayoutService'));
function getKeyboardLayoutId(layout) {
    if (layout.name) {
        return layout.name;
    }
    if (layout.id) {
        return layout.id;
    }
    return layout.layout;
}
export { IKeyboardLayoutService, getKeyboardLayoutId };
